export default {
    sentryDsn: process.env.REACT_APP_SENTRY_DSN || '',
    apiUrl:
        process.env.REACT_APP_API_URL ||
        'https://api-prod-pvt.snackpass.co/api/v4'
};
